
import BreadcrumbView from "../common/breadcrumb/breadcrumb.html";
import ProvidersListView from "./providers-list.html";
import ProvidersEditView from "./providers-edit.html";

angular.module("providers", [])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('providers', {
                url: "/providers",
                abstract: true,
                controller: "BreadcrumbCtrl",
                template: BreadcrumbView,
            })

            .state('providers.list', {
                url: "/list",
                controller: "ProvidersListCtrl",
                template: ProvidersListView,
                data: { pageTitle: 'Proveedores' },
                requiredPermission: ["PROVIDERS_READ"]
            })
            .state('providers.edit', {
                url: "/edit/:id",
                controller: "ProvidersEditCtrl",
                template: ProvidersEditView,
                data: { pageTitle: 'Proveedores' },
                requiredPermission: ["PROVIDERS_READ"]
            })
    }])
    ;